import { reatomAsync } from "@reatom/async";
import { UpdateDataExportTaskRequestDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { toastHandler, truncateStart } from "src/util";

export const updateExportTasksRequest = reatomAsync(
  async (_, data: UpdateDataExportTaskRequestDto) => {
    return API.exporterQueueApi
      .exportControllerUpdateExportTask(data)
      .then((response) => {
        if (response.data)
          toastHandler.success({
            name: "updateExportTasks",
            title: "Сохранение задачи",
            content: `Данные задачи ${truncateStart(data.id)} сохранены`,
          });
      });
  },
  "updateExportTasksRequest",
);
